export default __webpack_public_path__ + "static/116-72234a81c752e64d123b927a07614980.gif";